import './style.less'
import * as React from 'react'
import {loading} from '@redux/actions/loading'
import {connect} from 'react-redux'

interface IPageLoadingIndicatorDispatchProps {
  showGlobalSpinner: () => void
}

const PageLoadingIndicatorComponent = (props: IPageLoadingIndicatorDispatchProps) => {
  const {showGlobalSpinner} = props

  React.useEffect(() => {
    showGlobalSpinner()
  }, [])

  return null
}

const mapDispatchToProps = (dispatch): IPageLoadingIndicatorDispatchProps => {
  return {
    showGlobalSpinner: () => dispatch(loading(true)),
  }
}

export const PageLoadingIndicator = connect<null, IPageLoadingIndicatorDispatchProps>(
  null,
  mapDispatchToProps,
)(PageLoadingIndicatorComponent)
